import { render, staticRenderFns } from "./component-order-detaile-view.vue?vue&type=template&id=2ddf6c86"
import script from "./component-order-detaile-view.vue?vue&type=script&lang=js"
export * from "./component-order-detaile-view.vue?vue&type=script&lang=js"
import style0 from "./component-order-detaile-view.vue?vue&type=style&index=0&id=2ddf6c86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports